import { Component, inject, signal, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentJustificationRepository } from '@/store/payment-justification-state/payment-justification-state.repository';
import { PaymentJustificationService } from '../payment-justification.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { toSignal } from '@angular/core/rxjs-interop';
import { SocieteDacListItem } from '@/types';

@Component({
  selector: 'sm-payment-justification-detail',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './payment-justification-detail.component.html',
})
export class PaymentJustificationDetailComponent {
  store = inject(PaymentJustificationRepository);
  service = inject(PaymentJustificationService);
  sanitizer = inject(DomSanitizer);

  details = toSignal<SocieteDacListItem | null>(this.store.getObservable('response'));

  docUrl = signal<SafeResourceUrl | null>(null);
  loadingDoc = signal<boolean>(false);

  constructor() {
    effect(() => {
      const d = this.details();
      if (d?.justifPaiementId) {
        this.loadingDoc.set(true);
        this.service.downloadJustificationDocument(d.justifPaiementId).subscribe({
          next: blob => {
            const url = URL.createObjectURL(blob);
            this.docUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(url));
            this.loadingDoc.set(false);
          },
          error: () => {
            this.loadingDoc.set(false);
          },
        });
      } else {
        this.docUrl.set(null);
      }
    });
  }
}
